





















import { Doughnut } from 'vue-chartjs/legacy';
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale } from 'chart.js';
import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { DashboardModule } from '@/store/Dashboard/DashboardModule';

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

@Component({ name: 'AccountsByProductChart', components: { Doughnut } })
export default class extends SaascadaVue {

    get chartData() {
        return {
            labels: [
                `Current Accounts`,
                `Fixed Term Deposits`,
                `Savings Accounts`,
                `Fixed Term Loans`,
            ],
            datasets: [{
                backgroundColor: [
                    this.$vuetify.theme.currentTheme.primary,
                    this.$vuetify.theme.currentTheme.secondary,
                    this.$vuetify.theme.currentTheme.success,
                    this.$vuetify.theme.currentTheme.warning,
                ],
                data: [
                    1145,
                    350,
                    72,
                    101,
                ]
            }]
        };
    }

    get chartOptions() {
        return {
            responsive: true,
            maintainAspectRatio: false
        };
    }

    get styles() {
        return {
            height: "300px",
            position: "relative"
        };
    }

}
